export const NOTIFICATION_LEVEL = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
} as const;

export type NotificationLevel = (typeof NOTIFICATION_LEVEL)[keyof typeof NOTIFICATION_LEVEL];
